import { badge, riskColor } from '../../lib/format';
import { cardPad, Th } from '../../lib/ui';
import { useApp } from '../../state/AppContext';

export default function Exec() {
  const { L } = useApp();
  const execKpis = [
    { label: L('Total Spend (YTD)', 'ยอดใช้จ่ายรวม (ปีถึงปัจจุบัน)'), value: '$48.75M', delta: L('▲ 8.2% vs last period', '▲ 8.2% เทียบงวดก่อน'), deltaColor: 'var(--color-success)' },
    { label: L('Savings vs LPP', 'การประหยัดเทียบ LPP'), value: '$3.12M', delta: L('6.4% savings rate', 'อัตราการประหยัด 6.4%'), deltaColor: 'var(--color-fg-3)' },
    { label: L('Active RFQs', 'RFQ ที่ดำเนินการ'), value: '4', delta: L('▲ +1 vs last month', '▲ +1 เทียบเดือนก่อน'), deltaColor: 'var(--color-success)' },
    { label: L('Override Rate', 'อัตราการแทนที่'), value: '8.3%', delta: L('▼ 1.2 vs last period', '▼ 1.2 เทียบงวดก่อน'), deltaColor: 'var(--color-success)' },
  ];

  const spendCats = [
    { label: L('Insurance', 'ประกันภัย'), pct: 46 },
    { label: L('Automotive Parts', 'ชิ้นส่วนยานยนต์'), pct: 31 },
    { label: L('Services', 'บริการ'), pct: 15 },
    { label: L('IT & Office', 'ไอทีและสำนักงาน'), pct: 5 },
    { label: L('Other', 'อื่นๆ'), pct: 3 },
  ].map((c) => ({ ...c, w: c.pct + '%' }));

  const savings = [220, 310, 480, 390, 620, 890];
  const maxSav = 890;
  const savingsBars = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'].map((m, i) => ({
    month: m,
    val: savings[i] + 'K',
    h: (savings[i] / maxSav) * 100 + '%',
    color: i === 5 ? 'var(--color-primary)' : 'var(--color-blue-300)',
  }));

  const exc = [
    { id: 'FF-2026-0018', type: L('Collusion', 'การสมรู้ร่วมคิด'), risk: 72, ref: 'RFQ-2026-004', status: 'Open', detected: '2026-06-08' },
    { id: 'RPT-2026-001', type: L('Related Party', 'บุคคลที่เกี่ยวโยงกัน'), risk: 64, ref: 'PO-2026-0035', status: 'Not Disclosed', detected: '2026-06-05' },
  ];
  const execExceptions = exc.map((e) => {
    const b = badge(e.status);
    return { ...e, riskColor: riskColor(e.risk), stBg: b.bg, stFg: b.fg };
  });

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 16 }}>
        {execKpis.map((k) => (
          <div key={k.label} style={cardPad(18)}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)', marginBottom: 8 }}>{k.label}</div>
            <div style={{ fontSize: 28, fontWeight: 700, fontFamily: 'var(--font-mono)', letterSpacing: '-.02em' }}>{k.value}</div>
            <div style={{ fontSize: 12, fontWeight: 600, color: k.deltaColor, marginTop: 4 }}>{k.delta}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        <div style={cardPad(20)}>
          <div style={{ fontWeight: 700, marginBottom: 16 }}>{L('Spend by Category', 'ยอดใช้จ่ายตามหมวดหมู่')}</div>
          {spendCats.map((c) => (
            <div key={c.label} style={{ marginBottom: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 5 }}>
                <span style={{ fontWeight: 500 }}>{c.label}</span>
                <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{c.pct}%</span>
              </div>
              <div style={{ height: 8, borderRadius: 999, background: 'var(--color-ink-50)', overflow: 'hidden' }}>
                <div style={{ height: '100%', width: c.w, background: 'var(--color-blue)' }} />
              </div>
            </div>
          ))}
        </div>
        <div style={cardPad(20)}>
          <div style={{ fontWeight: 700, marginBottom: 16 }}>{L('Monthly Savings vs LPP ($)', 'การประหยัดรายเดือนเทียบ LPP ($)')}</div>
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 12, height: 180, paddingTop: 10 }}>
            {savingsBars.map((b) => (
              <div key={b.month} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', height: '100%' }}>
                <div style={{ fontSize: 11, fontFamily: 'var(--font-mono)', fontWeight: 600, marginBottom: 6 }}>{b.val}</div>
                <div style={{ width: '100%', borderRadius: '6px 6px 0 0', background: b.color, height: b.h }} />
                <div style={{ fontSize: 11, color: 'var(--color-fg-3)', marginTop: 6 }}>{b.month}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={cardPad(0, 'auto')}>
        <div style={{ padding: '14px 18px', fontWeight: 700, borderBottom: '1px solid var(--color-border)' }}>{L('Recent Compliance Exceptions', 'ข้อยกเว้นการกำกับดูแลล่าสุด')}</div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <Th>{L('Flag ID', 'รหัสการแจ้งเตือน')}</Th>
              <Th>{L('Type', 'ประเภท')}</Th>
              <Th>{L('Reference', 'อ้างอิง')}</Th>
              <Th>{L('Risk Score', 'คะแนนความเสี่ยง')}</Th>
              <Th>{L('Status', 'สถานะ')}</Th>
              <Th>{L('Detected', 'ตรวจพบ')}</Th>
            </tr>
          </thead>
          <tbody>
            {execExceptions.map((e) => (
              <tr key={e.id} style={{ borderBottom: '1px solid var(--color-border)' }}>
                <td style={{ padding: '11px 16px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{e.id}</td>
                <td style={{ padding: '11px 16px' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ width: 8, height: 8, borderRadius: 999, background: e.riskColor }} />
                    {e.type}
                  </span>
                </td>
                <td style={{ padding: '11px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{e.ref}</td>
                <td style={{ padding: '11px 16px', fontFamily: 'var(--font-mono)', fontWeight: 600, color: e.riskColor }}>{e.risk}</td>
                <td style={{ padding: '11px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: e.stBg, color: e.stFg }}>{e.status}</span>
                </td>
                <td style={{ padding: '11px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{e.detected}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
